import { render, staticRenderFns } from "./customBadge.vue?vue&type=template&id=cc098d12&"
import script from "./customBadge.vue?vue&type=script&lang=js&"
export * from "./customBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports